export default function pointEqual(a, b) {
  return a && b && a[0] === b[0] && a[1] === b[1];
}